module.exports = __webpack_public_path__ + "static/media/examination-icon-3.de477567.png";